// extracted by mini-css-extract-plugin
export default {"sectionContainer":"section_sectionContainer__Gam5l","imageContainer":"section_imageContainer__iH753","sectionImage":"section_sectionImage__q2f3O"};